import PropTypes from 'prop-types';
import React from "react";

const OptionSelectAction = ({ onClick, children }) => <div onClick={onClick} className="item">{children}</div>;
Option.propTypes = {
	children: PropTypes.any.isRequired,
	onClick: PropTypes.func.isRequired,
};

export default OptionSelectAction;